<template>
	<footer>
		<div class="footer-container">
			<!-- 左侧：联系方式和社交媒体 -->
			<div class="contact-section">
				<h3 class="section-title">{{ $t('footer.title') }}</h3>
				<p class="contact-text">{{ $t('footer.contactPrompt') }}</p>

				<div class="social-media">
					<!-- 泛思特小程序 -->
					<div class="social-icon-wrapper">
						<a href="#" class="social-icon tiktok-icon" aria-label="微信小程序">
							<svg class="tiktok-svg mini-program-icon" viewBox="0 0 72 72" version="1.1"
								xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
								<g stroke="green" fill="green" id="multitaskBar_miniProgram_logo" stroke-width="1" fill-rule="evenodd">
									<g fill="green" id="Icons/Dark/*star" fill-rule="nonzero">
										<path
											d="M49,9 C45.693,9 42.614,9.879 40,11.374 C35.205,14.118 32,18.968 32,24.5 L32,47.5 C32,51.642 27.97,55 23,55 C18.029,55 14,51.642 14,47.5 C14,44.552 16.046,42.009 19.015,40.783 C19.229,40.695 19.446,40.611 19.669,40.537 C21.538,39.787 23.141,38.379 23.736,36.744 C24.615,34.33 22.979,32.374 20.083,32.374 C19.361,32.374 18.629,32.496 17.923,32.716 C17.92,32.717 17.917,32.718 17.913,32.719 C13.726,33.921 10.231,36.557 8.133,40 C6.778,42.225 6,44.78 6,47.5 C6,56.047 13.626,63 23,63 C26.307,63 29.386,62.121 32,60.626 C36.795,57.882 40,53.032 40,47.5 L40,24.5 C40,20.358 44.029,17 49,17 C53.97,17 58,20.358 58,24.5 C58,27.574 55.781,30.216 52.604,31.374 C50.555,32.061 48.876,33.544 48.236,35.301 C47.362,37.703 48.99,39.651 51.873,39.651 C52.526,39.651 53.186,39.539 53.829,39.357 C53.934,39.328 54.038,39.296 54.142,39.265 C58.304,38.056 61.778,35.428 63.866,32 C65.222,29.776 66,27.22 66,24.5 C66,15.953 58.374,9 49,9"
											id="Mask" />
									</g>
								</g>
							</svg>
						</a>
						<div class="qr-popup">
							<div class="phone-mockup">
								<div class="phone-screen">
									<div class="app-header">
										<div class="app-icon">
											<img src="@/assets/images/gzh.jpg" alt="小程序图标">
										</div>
										<div class="app-name">泛思特小程序</div>
									</div>
									<div class="qr-code">
										<img src="@/assets/images/xiaochengxu.jpg" alt="小程序码">
									</div>
									<div class="hint-text">微信扫一扫打开小程序</div>
								</div>
							</div>
						</div>
					</div>

					<!-- 鉴定宝小程序 -->
					<div class="social-icon-wrapper">
						<a href="#" class="social-icon tiktok-icon" aria-label="微信鉴定宝" rel="noopener noreferrer">
							<svg class="tiktok-svg mini-program-icon" viewBox="0 0 72 72" version="1.1"
								xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
								<g id="multitaskBar_miniProgram_logo" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
									<g id="Icons/Dark/*star" fill="currentColor" fill-rule="nonzero">
										<path
											d="M49,9 C45.693,9 42.614,9.879 40,11.374 C35.205,14.118 32,18.968 32,24.5 L32,47.5 C32,51.642 27.97,55 23,55 C18.029,55 14,51.642 14,47.5 C14,44.552 16.046,42.009 19.015,40.783 C19.229,40.695 19.446,40.611 19.669,40.537 C21.538,39.787 23.141,38.379 23.736,36.744 C24.615,34.33 22.979,32.374 20.083,32.374 C19.361,32.374 18.629,32.496 17.923,32.716 C17.92,32.717 17.917,32.718 17.913,32.719 C13.726,33.921 10.231,36.557 8.133,40 C6.778,42.225 6,44.78 6,47.5 C6,56.047 13.626,63 23,63 C26.307,63 29.386,62.121 32,60.626 C36.795,57.882 40,53.032 40,47.5 L40,24.5 C40,20.358 44.029,17 49,17 C53.97,17 58,20.358 58,24.5 C58,27.574 55.781,30.216 52.604,31.374 C50.555,32.061 48.876,33.544 48.236,35.301 C47.362,37.703 48.99,39.651 51.873,39.651 C52.526,39.651 53.186,39.539 53.829,39.357 C53.934,39.328 54.038,39.296 54.142,39.265 C58.304,38.056 61.778,35.428 63.866,32 C65.222,29.776 66,27.22 66,24.5 C66,15.953 58.374,9 49,9"
											id="Mask" />
									</g>
								</g>
							</svg>
						</a>
						<div class="qr-popup">
							<div class="phone-mockup">
								<div class="phone-screen">
									<div class="app-header">
										<div class="app-icon">
											<img src="@/assets/images/logo.png" alt="鉴定宝图标">
										</div>
										<div class="app-name">鉴定宝小程序</div>
									</div>
									<div class="qr-code">
										<img src="@/assets/images/jiandingbao.jpg" alt="鉴定宝小程序码">
									</div>
									<div class="hint-text">微信扫一扫打开鉴定宝</div>
								</div>
							</div>
						</div>
					</div>

					<!-- 抖音 -->
					<a href="https://www.douyin.com/user/MS4wLjABAAAAxD3qTDDJc_RIUMY9-OcAad7l1MXK3WjXe3qZ8ceHf8E?from_tab_name=main&relation=2&vid=6969768641470516515"
						class="social-icon tiktok-icon" aria-label="抖音" target="_blank" rel="noopener noreferrer">
						<svg class="tiktok-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
						</svg>
					</a>
					<a href="https://www.xiaohongshu.com/user/profile/62cbec990000000002003b85?xsec_token=ABQB8pO48dIW4GXLO34dZt3cXiSYCXM1Li9ZF0NMa-c9M=&xsec_source=pc_search"
						class="xiaohongshu-icon" aria-label="小红书" target="_blank" rel="noopener noreferrer">
						<svg viewBox="0 0 1024 1024" class="xhs-svg" xmlns="http://www.w3.org/2000/svg">
							<rect class="xhs-bg" x="0" y="0" width="1024" height="1024" rx="180" ry="180" />
							<text x="50%" y="55%" text-anchor="middle" font-size="300" font-weight="bold" font-family="sans-serif"
								class="xhs-text" dominant-baseline="middle">
								小红书
							</text>
						</svg>
					</a>

				</div>
			</div>

			<!-- 右侧：公司信息 -->
			<div class="company-info">
				<div class="info-item">
					<i class="el-icon-location"></i>
					<span>{{ $t('footer.address') }}</span>
				</div>
				<div class="info-item">
					<i class="el-icon-chat-dot-round"></i>
					<span>{{ $t('footer.qq') }}</span>
				</div>
				<div class="info-item">
					<i class="el-icon-phone"></i>
					<span>{{ $t('footer.phone') }}</span>
				</div>
				<div class="info-item">
					<i class="el-icon-document"></i>
					<span>{{ $t('footer.fax') }}</span>
				</div>
				<div class="info-item">
					<i class="el-icon-message"></i>
					<span>{{ $t('footer.email') }}</span>
				</div>
			</div>
		</div>
		<div class="copyright-container">
			<div class="copyright">
				<div class="record-links">
					<span><img style="display: inline-block;margin: 0 6px" src="@/assets/images/balogo.png" />
					</span>
					<a class="record-link" target="_blank" :href="$t('footer.beian.publicSecurityUrl')">
						{{ $t('footer.beian.publicSecurity') }}
					</a>
					<span class="link-divider">|</span>
					<a class="record-link" target="_blank" :href="$t('footer.beian.icpUrl')">
						{{ $t('footer.beian.icp') }}
					</a>
				</div>
				<div class="copyright-text">{{ $t('footer.copyright') }}</div>

			</div>
		</div>
	</footer>
</template>

<script>
	export default {
		name: 'FooterComponent'
	};
</script>

<style scoped>
	footer {
		background-color: #2c3e50;
		color: #fff;
		padding: 40px 0 20px;
		font-family: 'Helvetica Neue', Arial, sans-serif;
	}

	.footer-container {
		max-width: 1200px;
		margin: 0 auto;
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 80px;
		padding: 0 20px;
	}

	.contact-section {
		.section-title {
			font-size: 24px;
			margin-bottom: 10px;
			color: #fff;
		}

		.contact-text {
			font-size: 16px;
			margin-bottom: 20px;
			color: #ecf0f1;
		}
	}

	.social-media {
		display: flex;
		flex-wrap: wrap;
		gap: 15px;
		align-items: center;

		.social-icon {
			display: inline-flex;
			justify-content: center;
			align-items: center;
			width: 40px;
			height: 40px;
			border-radius: 50%;
			border: 2px solid white;
			background-color: transparent;
			transition: all 0.3s ease;
			overflow: hidden;

			&:hover {
				transform: scale(1.1);
			}

			img {
				width: 22px;
				height: 22px;
				object-fit: contain;
			}
		}
	}

	.company-info {
		display: flex;
		flex-direction: column;
		gap: 12px;

		.info-item {
			display: flex;
			align-items: flex-start;
			gap: 10px;
			font-size: 14px;
			line-height: 1.5;

			i {
				color: #3498db;
				font-size: 16px;
				margin-top: 2px;
			}

			span {
				flex: 1;
			}
		}
	}

	.copyright-container {
		padding: 16px 0;
		margin-top: 30px;
		border-top: 1px solid rgba(255, 255, 255, 0.1);
	}

	.copyright {
		text-align: center;
		color: #bdc3c7;
		font-size: 14px;
	}

	.record-links {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		justify-content: center;
		gap: 8px;
	}

	.record-link {
		color: rgba(255, 255, 255, 0.9);
		font-size: 12px;
		text-decoration: none;
		transition: color 0.3s ease;

		&:hover {
			color: #409EFF;
			text-decoration: underline;
		}
	}

	.link-divider {
		color: rgba(255, 255, 255, 0.5);
		font-size: 12px;
	}

	.copyright-text {
		color: rgba(255, 255, 255, 0.7);
		font-size: 12px;
		margin-top: 8px;
	}

	/* 微信小程序悬浮效果 */
	.social-icon-wrapper {
		position: relative;
		display: inline-block;
		height: 40px;

		&:hover {
			.qr-popup {
				opacity: 1;
				visibility: visible;
				transform: translateX(-50%) translateY(0);
			}
		}
	}

	.qr-popup {
		position: absolute;
		bottom: calc(100% + 12px);
		left: 50%;
		transform: translateX(-50%) translateY(10px);
		width: 180px;
		opacity: 0;
		visibility: hidden;
		transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
		z-index: 10;

		&::before {
			content: '';
			position: absolute;
			bottom: -10px;
			left: 50%;
			transform: translateX(-50%);
			border-width: 10px 10px 0;
			border-style: solid;
			border-color: #fff transparent transparent;
		}
	}

	.phone-mockup {
		background: #fff;
		border-radius: 12px;
		box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
		overflow: hidden;
	}

	.phone-screen {
		padding: 15px;
		text-align: center;
	}

	.app-header {
		margin-bottom: 10px;

		.app-icon {
			width: 40px;
			height: 40px;
			margin: 0 auto 5px;
			border-radius: 8px;
			overflow: hidden;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		.app-name {
			font-size: 14px;
			font-weight: bold;
			color: #333;
		}
	}

	.qr-code {
		width: 120px;
		height: 120px;
		margin: 0 auto 10px;
		padding: 5px;
		background: #fff;
		border: 1px solid #eee;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	.hint-text {
		font-size: 12px;
		color: #666;
	}

	/* 抖音图标样式 */
	.tiktok-icon {
		&:hover {
			background-color: white;

			.tiktok-svg {
				fill: #000000;
				color: #000000;
			}
		}
	}

	.xiaohongshu-icon {
		display: inline-block;
		width: 45px;
		height: 45px;
		border: 2px solid #ffffff;
		border-radius: 50%;
		box-sizing: border-box;
		transition: border-color 0.3s, transform 0.3s ease;
		/* 过渡效果 */

		.xhs-svg {
			width: 100%;
			height: 100%;
			border-radius: 50%;
			display: block;
		}

		.xhs-bg {
			fill: transparent;
			transition: fill 0.3s;
		}

		.xhs-text {
			fill: #ffffff;
			transition: fill 0.3s;
		}

		&:hover {
			/* border-color: #ffffff; */
			cursor: pointer;
			transform: scale(1.1);
			/* 放大10% */
		}

		&:hover .xhs-bg {
			fill: #ffffff;
		}

		&:hover .xhs-text {
			fill: #000000;
			color: #000000;
		}
	}



	.tiktok-svg {
		width: 20px;
		height: 20px;
		fill: white;
		color: #fff;
		transition: all 0.3s ease;
	}

	.mini-program-icon {
		width: 25px;
		height: 25px;
	}

	/* 响应式设计 */
	@media (min-width: 1024px) {
		.desktop-menu {
			display: flex;

			.el-menu-item,
			.el-submenu__title {
				height: 80px;
				line-height: 80px;
			}
		}

		.mobile-menu-toggle,
		.mobile-menu {
			display: none;
		}

		.header-container {
			justify-content: space-around;
		}
	}

	@media (max-width: 1023px) {
		.desktop-menu {
			display: none;
		}

		.mobile-menu-toggle {
			display: flex;
		}
	}

	@media (max-width: 768px) {
		.footer-container {
			grid-template-columns: 1fr;
			gap: 30px;
		}

		.company-info {
			order: -1;
		}

		.social-media {
			justify-content: center;
		}

		.qr-popup {
			&.bottom-position {
				bottom: auto;
				top: calc(100% + 12px);

				&::before {
					bottom: auto;
					top: -10px;
					border-width: 0 10px 10px;
					border-color: transparent transparent #fff;
				}
			}
		}
	}

	@media (max-width: 576px) {
		.footer {
			padding: 30px 0 15px;
		}

		.contact-section {
			.section-title {
				font-size: 20px;
			}

			.contact-text {
				font-size: 14px;
			}
		}

		.company-info {
			.info-item {
				font-size: 13px;
				flex-direction: column;
				gap: 5px;

				i {
					margin-top: 0;
				}
			}
		}

		.social-media {
			gap: 12px;

			.social-icon {
				width: 36px;
				height: 36px;

				img {
					width: 20px;
					height: 20px;
				}
			}
		}

		.qr-popup {
			width: 160px;
		}

		.phone-screen {
			padding: 12px;
		}

		.qr-code {
			width: 110px;
			height: 110px;
		}
	}

	@media (max-width: 480px) {
		.logo {
			img {
				width: 50px;
			}

			.sgStyle {
				p {
					font-size: 16px;
				}

				label {
					font-size: 11px;
				}
			}
		}

		.qr-popup {
			width: 160px;

			.phone-screen {
				padding: 10px;
			}

			.qr-code {
				width: 100px;
				height: 100px;
			}
		}
	}
</style>